import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  production: false,
  apiBaseUrl: 'https://staging-api.octaveplanner.com',
  timeout: 30000,
  debug: false,
  features: {
    ...environmentBase.features,
    enableAnalytics: true,
    enableLogging: true,
    enableCache: true
  }
};